import { useInfiniteQuery } from 'react-query'
import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'

interface UseProps {
  query?: string
  pageSize: number
  imageType: 'illustration' | 'vector' | 'all'
}

interface FetchProps extends UseProps {
  page: number
}

export type PixabayImage = {
  id: string
  previewURL: string
  largeImageURL: string
  imageWidth: number
  imageHeight: number
}

type PixabayImageResponse = {
  hits: PixabayImage[]
  total: number
}

const fetch = async ({ page, query, pageSize, imageType }: FetchProps) => {
  const response = await sendToApi<PixabayImageResponse>(
    `/pixabay/images?query=${query}&page=${page}&per_page=${pageSize}&image_type=${imageType}`,
  )

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(response.data)
  }

  return {
    images: response.data.hits,
    nextPage: response.data.total > pageSize * page ? page + 1 : null,
  }
}

export const usePixabayElements = ({ query, pageSize, imageType }: UseProps) =>
  useInfiniteQuery<{ images: PixabayImage[]; nextPage: number | null }>(
    ['pixabay', { query, pageSize, imageType }],
    async ({ pageParam = 1 }) => fetch({ page: pageParam, query, pageSize, imageType }),
    {
      getNextPageParam: (lastPage) => lastPage.nextPage,
      cacheTime: Infinity,
      staleTime: Infinity,
    },
  )
